"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterMarkerFilledLevels = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../../icons");
var utils_1 = require("../utils");
var digitMap = {
    "11": icons_1.FilledLevelMarker1c1d,
    "12": icons_1.FilledLevelMarker1c2d,
    "13": icons_1.FilledLevelMarker1c3d,
    "14": icons_1.FilledLevelMarker1c3d,
    "21": icons_1.FilledLevelMarker2c1d,
    "22": icons_1.FilledLevelMarker2c2d,
    "23": icons_1.FilledLevelMarker2c3d,
    "24": icons_1.FilledLevelMarker2c3d,
    "31": icons_1.FilledLevelMarker3c1d,
    "32": icons_1.FilledLevelMarker3c2d,
    "33": icons_1.FilledLevelMarker3c3d,
    "34": icons_1.FilledLevelMarker3c3d,
    "41": icons_1.FilledLevelMarker4c1d,
    "42": icons_1.FilledLevelMarker4c2d,
    "43": icons_1.FilledLevelMarker4c3d,
    "44": icons_1.FilledLevelMarker4c3d,
};
var ClusterMarkerFilledLevels = function (_a) {
    var circles = _a.circles, hover = _a.hover, digit = _a.digit;
    var Marker = digitMap[utils_1.getLength(circles.length, 4).toString() + digit];
    if (hover) {
        return (react_1.default.createElement(Marker, { size: 15, circles: circles, color: "#F2F2F2", strokeColor: "#909DA9" }));
    }
    return (react_1.default.createElement(Marker, { color: "white", size: 15, strokeColor: "#909DA9", circles: circles }));
};
exports.ClusterMarkerFilledLevels = ClusterMarkerFilledLevels;
